<template>
    <div>
        <div class="p-fluid">
            <div class="formgrid grid">
                <div class="field col-12 md:col-6 lg:col-3">
                    <label for="period">Period</label>
                    <Calendar selectionMode="range"  v-tooltip.top="'Max 30 Days'" :manualInput="false" v-model="period" :maxDate="maxDate" dateFormat="dd/mm/yy" icon="pi pi-calendar" :showIcon="true"/>
                </div>
                <div class="field col-12 md:col-6 lg:col-3">
                    <label>PJP Type</label>
                    <Dropdown id="pjp_type" dataKey="pjp_type" v-model="filters.pjp_type"
                        :options="dataDropdownTerritory"
                        optionLabel="name" optionValue="code" placeholder="Select PJP Type"
                        :filter="true" :showClear="true"  />
                </div>
            </div>
        </div>
        <Button :loading="loading" label="Filter" icon="pi pi-search" class="p-button-warning mr-2 my-1" @click="getDataTable" />
    </div>
</template>

<script>

import moment from 'moment';

export default {
    data() {
        return {
            // loading
            loading: false,

            // dataDropdown
            dataDropdownTerritory: [
                {name: 'Normal', code: 'Normal'},
                {name: 'Deviation', code: 'Deviation'},
            ],

            // filter
            filters: {
                pjp_type: null,
            },
            period: [new Date(), new Date()],
            maxDate: null,
        }
    },
    mounted() {
    },
    created(){
    },
    watch: {
        period(){
            //max range 30 days
            this.maxDate =  new Date(this.period[0].getFullYear(), this.period[0].getMonth(), this.period[0].getDate() + 30);
        }
    },
    computed:{
        period_start_label(){ 
            return moment(this.period[0], 'YYYY-MM-DD').format('YYYY-MM-DD'); 
        },
        period_end_label(){ 
            return moment(this.period[1], 'YYYY-MM-DD').format('YYYY-MM-DD'); 
        },
    },
    methods: {
        getDataTable(){
            if(
              this.period_start_label !== null && 
              this.period_end_label !== null && 
              this.period_start_label !== 'Invalid date' && 
              this.period_end_label !== 'Invalid date'
            ){  
                this.$emit('submit');
            }else{
                 alert('Make sure the time range is correct or not empty');
            }
        }
    }
}
</script>

